module.exports = __webpack_public_path__ + "2fbdaf04eb66c87a0a856fc3c62a27ec.png";